const translations = {
  "en": {
    "Add manually": "Add manually",
    "Connect account": "Connect account",
    "Continue without connecting": "Continue without connecting",
    "Ed works best with your accounts": "Ed works best with your accounts",
    "Not now": "Not now",
    "Without them I'm working from estimates. With them, every move I hand you is your real money.": "Without them I'm working from estimates. With them, every move I hand you is your real money."
  },
  "zh-tw": {
    "Add manually": "手動新增",
    "Connect account": "連結帳戶",
    "Continue without connecting": "先不連結，繼續",
    "Ed works best with your accounts": "Ed 與你的帳戶搭配效果最佳。",
    "Not now": "稍後再說",
    "Without them I'm working from estimates. With them, every move I hand you is your real money.": "沒有它們，我只能基於估算進行操作。有了它們，我交給你的每一筆操作都將是你的實際資金。"
  }
};

export default translations;
